/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Aggregation = {
    Min: 'min',
    Max: 'max',
    Avg: 'avg',
    Sum: 'sum',
    Count: 'count',
    Newest: 'newest',
    None: 'none'
} as const;
export type Aggregation = typeof Aggregation[keyof typeof Aggregation];


export function instanceOfAggregation(value: any): boolean {
    for (const key in Aggregation) {
        if (Object.prototype.hasOwnProperty.call(Aggregation, key)) {
            if (Aggregation[key as keyof typeof Aggregation] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AggregationFromJSON(json: any): Aggregation {
    return AggregationFromJSONTyped(json, false);
}

export function AggregationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Aggregation {
    return json as Aggregation;
}

export function AggregationToJSON(value?: Aggregation | null): any {
    return value as any;
}

export function AggregationToJSONTyped(value: any, ignoreDiscriminator: boolean): Aggregation {
    return value as Aggregation;
}

